export default __webpack_public_path__ + "static/media/file-upload-fail.8021eaf3.svg";